<script>
import AppBlock from '@components/apps/app-block.vue'
import MottoIcon from '@components/motto-icon.vue'

export default {
  components: {
    AppBlock,
    MottoIcon,
  },
  props: {
    category: {
      type: String,
      default: '',
    },
    apps: {
      type: Array,
      required: true,
    },
    emptySentence: {
      type: String,
      default: 'No apps found',
    },
  },
}
</script>

<template>
  <div>
    <div class="d-flex justify-content-between">
      <h3 :class="$style.title">{{ category }}</h3>
      <MottoIcon
        v-if="apps.length"
        name="Grid"
        icon-color="lightGray"
        class="mr-4 cursor-pointer"
        @click.native="$emit('openGridView')" />
    </div>
    <p v-if="!apps.length" :class="$style.emptySentence">{{ emptySentence }}</p>
    <carousel
      v-if="apps.length"
      :class="$style.carousel"
      :per-page-custom="[
        [0, 4],
        [1584, 5],
        [1850, 6],
        [2120, 7],
        [2500, 8],
      ]"
      :pagination-enabled="false"
      :navigation-enabled="true"
      :navigation-next-label="''"
      :navigation-prev-label="''">
      <slide v-for="app in apps" :key="app.appId">
        <AppBlock
          :name="app.appName"
          :description="app.description"
          :category="app.category"
          :card-image="app.cardImage"
          :card-image-mobile="app.cardImageMobile"
          :app-url="app.appUrl"
          :app-id="app.appId"
          :class="$style.appBlock" />
      </slide>
    </carousel>
    <div v-if="apps.length" :class="$style.mobileCarousel">
      <AppBlock
        v-for="app in apps"
        :key="app.appId"
        :name="app.appName"
        :description="app.description"
        :category="app.category"
        :card-image="app.cardImage"
        :card-image-mobile="app.cardImageMobile"
        :app-url="app.appUrl"
        :app-id="app.appId"
        :class="$style.appBlock" />
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.mobileCarousel {
  @media (max-width: $lg-breakpoint) {
    display: flex;
    flex-wrap: nowrap;
    justify-content: flex-start;
    padding-bottom: 10px;
    overflow-x: scroll;
  }

  display: none;
}

.carousel {
  @media (max-width: $lg-breakpoint) {
    display: none;
  }

  > div {
    padding-bottom: 7px;
  }
}

.title {
  margin-bottom: 24px;
}

.emptySentence {
  color: $dark-gray;
  text-align: center;
}

.appBlock {
  @media (max-width: $lg-breakpoint) {
    div[class*='appBlockMobile'] {
      margin-right: 16px;
    }
  }

  height: 100%;
}
</style>
